import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tenantAuthReducer from './slices/tenantAuthSlice';
import tenantSettingReducer from './slices/tenantSettingSlice';
import executivePortalReducer from './slices/executivePortalSlice';
import executivePortalTenantManagementReducer from './slices/executivePortalTenantManagementSlice';
import chatterTrackerReducer from './slices/chatterSlice';
import alertMessageReducer from './slices/alertMessageSlice';
import previewReducer from './slices/previewDataSlice';
import topicReducer from './slices/topicSlice';
import sentinelHubReducer from './slices/sentinelHubSlice';
import competitiveIntelligenceReducer from './slices/competitiveIntelligenceSlice';
import ConsoleReducer from './slices/homePageSlice'
import filterPanelReducer from './slices/filterPanelSlice';
import alertReducer from './slices/alertSlice';
import enterpriseReducer from './slices/enterpriseSlice'
import operationReducer from './slices/operationSlice'

const rootReducer = combineReducers({
  // Authentication reducers
  auth: authReducer,
  tenantAuth: tenantAuthReducer,

  // Settings and portal-related reducers
  tenantSetting: tenantSettingReducer,
  executivePortal: executivePortalReducer,
  executivePortalTenantManagement: executivePortalTenantManagementReducer,

  // Data handling reducers
  chatterTracker: chatterTrackerReducer,
  preview: previewReducer,
  topicBuilder: topicReducer,
  ConsoleBuilder:ConsoleReducer,
  sentinelHub: sentinelHubReducer,
  alert:alertReducer,
  // Competitive intelligence reducer
  competitiveIntelligence: competitiveIntelligenceReducer,

  // Alerts and messaging
  message: alertMessageReducer,

  //Filter Panel Payload for Drill Through
  filterPanel: filterPanelReducer,
  enterprise:enterpriseReducer,
  operations:operationReducer
});

export default rootReducer;
